// extracted by mini-css-extract-plugin
export var headerCell = "_1c-1";
export var loadingSpinnerContainer = "_1c-4";
export var rowWrapper = "_1c-3";
export var standaloneTable = "_1c-5";
export var table = "_1c-0";
export var white = "_1c-2";